import React from 'react';

import NavBarTrigger, { NavBarTriggerProps } from './NavBarTrigger';

const HomePageNavBarTrigger = (props: NavBarTriggerProps) => (
  <NavBarTrigger type="homepage" {...props} />
);

export default HomePageNavBarTrigger;
